import RouteWrapper from "@/components/common/RouteWrapper.vue";
import RouteNames from "@/entities/RouteNames";
import NavigationIcons from "@/entities/NavigationIcons";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import RouteSectionsPrefixes from "@/entities/RouteSectionsPrefixes";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import sidebarData from "@/data/sidebar";
import Roles from "@/entities/Roles";

const PricePlansProfile = () =>
  import("@/views/paymentV2/index.vue").then((m) => m.default);
const Inbox = () => import("@/views/inbox/InboxNew.vue").then((m) => m.default);
const Settings = () =>
  import("@/views/settings/Settings.vue").then((m) => m.default);
const CompanyProfile = () =>
  import("@/views/settings/CompanyProfile.vue").then((m) => m.default);
const CompanySettings = () =>
  import("@/views/settings/CompanySettingsTabs.vue").then((m) => m.default);
const CompanyInterfaceSettings = () =>
  import("@/views/settings/CompanyInterfaceSettings.vue").then(
    (m) => m.default
  );
const MarketplaceAccessRequests = () =>
  import("@/views/settings/MarketplaceAccessRequests.vue").then(
    (m) => m.default
  );
const Profile = () =>
  import("@/views/settings/Profile.vue").then((m) => m.default);
const Notifications = () =>
  import("@/components/notification/AllNotifications.vue").then(
    (m) => m.default
  );

  const admin = sidebarData.find(
    (a) =>
      (a.role.includes(Roles.ADMIN) || a.role.includes(Roles.MANAGER)) &&
      a.slug === "/directory"
  );
  const contractor = sidebarData.find((a) => a.role.includes(Roles.CONTRACTOR));

const getMyInboxRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/inbox",
    component: RouteWrapper,
    meta: {
      title: "Inbox",
      customLayout: true,
      breadcrumb: {
        title: (user) =>
        user?.role === Roles.CONTRACTOR
          ? (contractor.title as string)
          : (admin.title as string),
      routeName: RouteNames.INBOX,
        isStyled: true,
      },
    },
    children: [
      {
        path: "",
        name: RouteNames.INBOX,
        component: Inbox,
        props: true,
        meta: {
          customLayout: true,
          title: BreadcrumbsTitles.INBOX,
          breadcrumb: {
            title: BreadcrumbsTitles.INBOX,
            routeName: RouteNames.INBOX,
            isStyled: true,
          },
        },
      },
      {
        path: "conversation/:conversationId",
        name: RouteNames.INBOX_CONVERSATION,
        component: Inbox,
        props: true,
        meta: {
          customLayout: true,
          title: BreadcrumbsTitles.COMPANY_RESOURCES,
          breadcrumb: {
            title: BreadcrumbsTitles.INBOX,
            isStyled: true,
          },
        },
      },
    ],
  },
]);

const getProfilesRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/profile",
    component: RouteWrapper,
    props: true,
    children: [
      {
        path: "",
        name: RouteNames.PROFILE,
        component: Profile,
        meta: {
          title: "User Profile",
          breadcrumb: {
            title: BreadcrumbsTitles.USER_PROFILE,
            icon: NavigationIcons.SETTINGS,
            isStyled: true,
          },
        },
      },
      {
        path: "user",
        name: RouteNames.USER_PROFILE,
        component: Settings,
        meta: {
          title: "User Settings",
          breadcrumb: {
            title: BreadcrumbsTitles.USER_SETTINGS,
            icon: NavigationIcons.SETTINGS,
            isStyled: true,
          },
        },
      },
      {
        path: "pricing",
        name: RouteNames.PRICING,
        component: PricePlansProfile,
      },
      {
        path: "company",
        name: RouteNames.COMPANY_PROFILE,
        component: CompanyProfile,
        meta: {
          title: "Company Profile",
          roles: [Roles.ADMIN],
          breadcrumb: {
            title: BreadcrumbsTitles.COMPANY_PROFILE,
            icon: NavigationIcons.SETTINGS,
            isStyled: true,
          },
        },
      },
      {
        path: "settings",
        component: CompanySettings,
        meta: {
          title: "Permissions",
          roles: [Roles.ADMIN],
          breadcrumb: {
            title: BreadcrumbsTitles.COMPANY_SETTINGS,
            isStyled: true,
          },
        },
        children: [
          {
            path: "interface",
            name: RouteNames.COMPANY_INTERFACE_SETTINGS,
            component: CompanyInterfaceSettings,
            props: true,
           // meta:{
          //   breadcrumb: {
          //     title: BreadcrumbsTitles.COMPANY_PROFILE,
          //     isStyled: true,
          //   },
          // }
          },
          {
            path: "marketplace_access_requests",
            name: RouteNames.COMPANY_MARKETPLACE_ACCESS_REQUESTS,
            component: MarketplaceAccessRequests,
            props: true,
            // meta:{
            //   breadcrumb: {
            //     title: BreadcrumbsTitles.COMPANY_PROFILE,
            //     isStyled: true,
            //   },
            // }
          },
        ],
      },
    ],
  },
]);

const getNotificationsPageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/notifications",
    component: RouteWrapper,
    meta: {
      breadcrumb: {
        title: BreadcrumbsTitles.NOTIFICATIONS,
        icon: NavigationIcons.NOTIFICATIONS,
        isStyled: true,
      },
    },
    children: [
      {
        path: "",
        name: RouteNames.NOTIFICATIONS,
        component: Notifications,
      },
    ],
  },
]);

export { getMyInboxRoutes, getProfilesRoutes, getNotificationsPageRoutes };
